import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'domainListHelper'
})
export class DomainListHelperPipe implements PipeTransform {

  transform(value: any, arg1: string): any {
    switch (arg1) {
      case 'type':
        return this.getDomainType(value);
      case 'status':
        return this.getDomainStatus(value);
      default:
        return value;
    }
  }


  private getDomainType(type: string) {
    switch (type) {
      case 'ROOT':
        return "Root";
      case "GENERIC":
        return "Generic";
      case "COUNTRY_CODE":
        return "Country Code";
      case "SPECIAL":
        return "Special";
      default:
        return type;
    }
  }

  private getDomainStatus(status: string) {
    switch (status) {
      case 'Reserved':
        return "warning";
      case "Eligible":
        return "primary";
      case "Inactive":
        return "secondary";
      case "Active":
        return "success";
      case "Former":
        return "alert";
      default:
        return "secondary";
    }
  }
}
